import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickProductRequestParams } from "@/features/pathpick/types/request-params";
import { PathPickProductsResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";
import { getHttpStatus, isRetryableApiError } from "@/utils/axios-client-error";

// 상품 조회 훅 — 상품 찾기 목록과 담긴 상품(isInBasket: true) 조회가 공용으로 사용
const useGetPathPickProducts = (params?: PathPickProductRequestParams) => {
  const { companyId } = useCompanyIdentity();

  const {
    data: pathPickProductList,
    isPending,
    isPlaceholderData,
    isError,
    error,
  } = useQuery({
    queryKey: ["pathpick", "api-products", companyId, params],
    // camel 변환을 queryFn에서 수행해 캐시 자체를 camel로 저장한다.
    // (낙관적 업데이트가 setQueryData로 camel 캐시를 직접 조작하기 위함)
    queryFn: async () => {
      const data = await pathPickQueryApi.getPathPickProducts(
        companyId as number,
        params
      );
      return toCamelKeyObject(data) as PathPickProductsResponse;
    },
    enabled: Boolean(companyId),
    placeholderData: keepPreviousData,
    // 429(검색 호출 제한)는 다시 물어봐도 같은 답이라 재시도하지 않는다 — 제한 창을 더 채우기만 한다.
    retry: (failureCount, err) =>
      getHttpStatus(err) !== 429 && isRetryableApiError(err) && failureCount < 3,
  });

  return { pathPickProductList, isPending, isPlaceholderData, isError, error };
};

export default useGetPathPickProducts;
